import { Asserts, object, string } from 'yup';

import { url } from './commonValidation';

export const trackFeedbackFormSchema = object({
  trackLink: url.required(),
  referenceLink: url,
  aspectsDescription: string(),
});

export type TrackFeedbackFormDataType = Asserts<
  typeof trackFeedbackFormSchema
>;
